import React, { useState } from "react";
import styles from "./index.module.scss";
import ButtonRade from "../../components/RadeButtons";
import { radexAuth } from "../../firebase";
import axios from "axios";

const ManualTx = () => {
  const [transferId, setTransferId] = useState("");
  const [personId, setPersonId] = useState("");
  const [inrAmount, setInrAmount] = useState("");
  const [senderName, setSenderName] = useState("");
  const [senderEmail, setSenderEmail] = useState("");
  const [senderAccNum, setSenderAccNum] = useState("");
  const [receiverName, setReceiverName] = useState("");
  const [receiverPhoneNum, setReceiverPhoneNum] = useState("");
  const [receiverAccNum, setReceiverAccNum] = useState("");
  const [receiverIfsc, setReceiverIfsc] = useState("");
  const [receiverBankName, setReceiverBankName] = useState("");
  const handleOnChangeTransferId = (e) => {
    setTransferId(e.target.value);
  };
  const handleOnChangePersonId = (e) => {
    setPersonId(e.target.value);
  };
  const handleOnChangeInrAmount = (e) => {
    setInrAmount(e.target.value);
  };
  const handleOnChangeSenderName = (e) => {
    setSenderName(e.target.value);
  };
  const handleOnChangeSenderEmail = (e) => {
    setSenderEmail(e.target.value);
  };
  const handleOnChangeSenderAccNum = (e) => {
    setSenderAccNum(e.target.value);
  };
  const handleOnChangeReciverName = (e) => {
    setReceiverName(e.target.value);
  };
  const handleOnChangeReciverPhoneNumber = (e) => {
    setReceiverPhoneNum(e.target.value);
  };
  const handleOnChangeReciverAccNum = (e) => {
    setReceiverAccNum(e.target.value);
  };
  const handleOnChangeReciverIfsc = (e) => {
    setReceiverIfsc(e.target.value);
  };
  const handleOnChangeReciverBankName = (e) => {
    setReceiverBankName(e.target.value);
  };
  const handleOnClickProcess = async () => {
    try {
      const paymentManualPayload = {
        transaction_id: transferId,
        person_id: personId,
        inr_amount_out: Number(inrAmount),
        beneficiary_details: {
          phone_number: receiverPhoneNum,
          name: receiverName,
          account_number: receiverAccNum,
          ifsc_code: receiverIfsc,
          bank_name: receiverBankName,
        },
        sender_details: {
          email: senderEmail,
          name: senderName,
          account_number: senderAccNum,
        },
      };

      const idToken = await radexAuth.currentUser.getIdToken(true);
      const response = await axios.post(
        `${process.env.REACT_APP_KIWI_SERVER_URI}/api/admin_cyrus/process_manual_payment`,
        paymentManualPayload,
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      );

      console.log("Transfer processed successfully:", response.data);
    } catch (error) {
      console.error("Error in manually processing the transfer", error);
    }
  };

  return (
    <div className={styles.manualTxMainContainer}>
      <div className={styles.inputContainer}>
        <input
          type="text"
          placeholder="Enter the Transfer Id"
          onChange={handleOnChangeTransferId}
          value={transferId}
          className={styles.inputValue}
        ></input>
      </div>
      <div className={styles.inputContainer}>
        <input
          type="text"
          placeholder="Enter the Person Id"
          onChange={handleOnChangePersonId}
          value={personId}
          className={styles.inputValue}
        ></input>
      </div>
      <div className={styles.inputContainer}>
        <input
          type="number"
          placeholder="Enter the INR amount"
          onChange={handleOnChangeInrAmount}
          value={inrAmount}
          className={styles.inputValue}
        ></input>
      </div>
      <div className={styles.inputContainer}>
        <input
          type="text"
          placeholder="Enter the sender name"
          onChange={handleOnChangeSenderName}
          value={senderName}
          className={styles.inputValue}
        ></input>
      </div>
      <div className={styles.inputContainer}>
        <input
          type="email"
          placeholder="Enter the sender email"
          onChange={handleOnChangeSenderEmail}
          value={senderEmail}
          className={styles.inputValue}
        ></input>
      </div>
      <div className={styles.inputContainer}>
        <input
          type="text"
          placeholder="Enter the sender account number"
          onChange={handleOnChangeSenderAccNum}
          value={senderAccNum}
          className={styles.inputValue}
        ></input>
      </div>
      <div className={styles.inputContainer}>
        <input
          type="text"
          placeholder="Enter the receiver name"
          onChange={handleOnChangeReciverName}
          value={receiverName}
          className={styles.inputValue}
        ></input>
      </div>
      <div className={styles.inputContainer}>
        <input
          type="text"
          placeholder="Enter the receiver phone number"
          onChange={handleOnChangeReciverPhoneNumber}
          value={receiverPhoneNum}
          className={styles.inputValue}
        ></input>
      </div>
      <div className={styles.inputContainer}>
        <input
          type="text"
          placeholder="Enter the receiver account number"
          onChange={handleOnChangeReciverAccNum}
          value={receiverAccNum}
          className={styles.inputValue}
        ></input>
      </div>
      <div className={styles.inputContainer}>
        <input
          type="text"
          placeholder="Enter the receiver IFSC"
          onChange={handleOnChangeReciverIfsc}
          value={receiverIfsc}
          className={styles.inputValue}
        ></input>
      </div>
      <div className={styles.inputContainer}>
        <input
          type="text"
          placeholder="Enter the receiver bank name"
          onChange={handleOnChangeReciverBankName}
          value={receiverBankName}
          className={styles.inputValue}
        ></input>
      </div>
      <ButtonRade
        customStyling={styles.processButton}
        onClick={handleOnClickProcess}
      >
        Process
      </ButtonRade>
    </div>
  );
};

export default ManualTx;
